import React, {Component} from "react"
import PropTypes from "prop-types"
import {Link, withRouter} from "react-router-dom"
import {Button} from "semantic-ui-react"
import {observer} from "mobx-react"
import shop from "shop/shop"
import queryString from "qs"
import Footer from "components/Footer/Footer"

@withRouter
@observer
class CheckoutLayout extends Component {
	render() {
		let {count, sum} = shop.cart
		const {referer = "/", ...query} = queryString.parse( location.search, {ignoreQueryPrefix: true} )
		const {checkoutType} = this.props.match.params
		const isRequest = !!checkoutType
		return (
			<div>
				<div id="page-wrap"
					 className="wrapper-wide ">
					<div style={{backgroundColor: "#E3E0CA"}} className="">
						<div className="container pv2-ns pv2" style={{animationDelay: "220ms"}}>
							<div className="flex flex-row justify-between items-center">
								<h1 className=""><i className="icon-basket icon-lg" />
									<strong>
										{isRequest ? <div className="ttu">{translate( "your request" )}</div> :
											shop.session && shop.session.shopuser && shop.session.shopuser.guest ? <div className="ttu">{translate( "your request" )}</div> :
											!shop.session ? <div className="ttu">{translate( "your request" )}</div> :
											<div className="ttu">{translate( "your order" )}</div>
										}
									</strong></h1>
								<div><Button style={{border: "none", background: "none"}}
										 icon="big close" as={Link} to={referer || "/"} /></div>
							</div>

							{/*Sie haben <strong> {count} Artikel im Warenkorb</strong> mit einem <strong> Warenwert von <Price>{sum}</Price></strong> netto.*/}
						</div>
					</div>
					<div id="page-container ">
						<div className=" " style={{animationDelay: "420ms"}}>
							{this.props.children}
						</div>
					</div>
				</div>
				<div className="pt5"></div>
				<Footer/>
			</div>
		)
	}
}

CheckoutLayout.propTypes = {
	children: PropTypes.any
}

export default CheckoutLayout



// WEBPACK FOOTER //
// ./src/theme/demo2025/layout/CheckoutLayout.js